import { APIRequestBody, APIResponse } from '../../types';
import { api } from '../../api';
import {
  ArgPeriod,
  SleepDiaryResultContent,
} from '@bighealth/types/src/services/SleepDiaryPayloads/get_sleep_diary_component_data_for_time_period';
import { AxiosRequestConfig } from 'axios';

export const get_sleep_diary_component_data_for_time_period = async (
  args: get_sleep_diary_component_data_for_time_period.Args,
  requestConfig?: AxiosRequestConfig
): Promise<get_sleep_diary_component_data_for_time_period.Response> => {
  const request: get_sleep_diary_component_data_for_time_period.Request = {
    service_name: 'SleepDiary',
    service_version: '1',
    service_method: 'get_sleep_diary_component_data_for_time_period',
    args,
  };

  return await api(request, requestConfig);
};

get_sleep_diary_component_data_for_time_period.queryKey =
  'SleepDiary/get_sleep_diary_component_data_for_time_period';

export declare namespace get_sleep_diary_component_data_for_time_period {
  export type Args = {
    user_timezone: string;
    is_read_only: boolean;
    include_metadata: boolean;
    product_id: number;
    program_id?: number;
    is_outside_content?: boolean;
  } & (
    | {
        period: ArgPeriod.calendar_week;
        calendar_week_offset?: number;
      }
    | {
        period: ArgPeriod.last_seven_days;
      }
  );

  export interface Request extends APIRequestBody {
    service_name: 'SleepDiary';
    service_version: '1';
    service_method: 'get_sleep_diary_component_data_for_time_period';
    args: Args;
  }

  export type Result = SleepDiaryResultContent;

  export type Response = APIResponse<Result>;
}
